const menuItems = [
    {
        path: "/dashboard/profile",
        label: "dashboard_drawer.menu_item_profile",
    },
    {
        path: "/dashboard/events",
        label: "dashboard_drawer.menu_item_events",
    },
    {
        path: "/dashboard/schools",
        label: "dashboard_drawer.menu_item_schools",
    },
];

export default menuItems;


// WEBPACK FOOTER //
// ./src/features/Dashboard/menuItems.js